/* ==========================================================================
   King's Compounds — Shared chrome + interactions (V3)
   Injects announcement, header, footer, ambient glow into every page and
   wires progress bar, mobile menu, accordions, scroll-reveal, count-up.
   Set <body data-page="shop|pay|coa|education|support"> to highlight nav.
   ========================================================================== */
(function(){
 // All site routes
var ROUTES = {
  HOME: '/',
  CATALOG: 'https://kingscompounds.com/pages/catalog',
  HOW_TO_PAY: 'https://kingscompounds.com/pages/how-to-pay',
  COA: 'https://kingscompounds.com/pages/coa',
  EDUCATION: 'https://kingscompounds.com/pages/education',
  FAQ: 'https://kingscompounds.com/pages/faqs',
  CONTACT: 'https://kingscompounds.com/pages/contact',
  AFFILIATE: 'https://kingscompounds.com/pages/affiliate',
  ABOUT: 'https://kingscompounds.com/pages/about-us',
  PRIVACY: 'https://kingscompounds.com/pages/privacy-policy',
  TERMS: 'https://kingscompounds.com/pages/terms-of-service',
  RETURNS: 'https://kingscompounds.com/pages/return-refunds',
  SHIPPING: 'https://kingscompounds.com/pages/shipping-policy-1',
  DATA_SHARING: 'https://kingscompounds.com/pages/data-sharing-opt-out'
};

var HOME = ROUTES.HOME;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var page = document.body.getAttribute('data-page') || '';

  var NAV = [
  {href: ROUTES.CATALOG, label:'Shop', key:'shop'},
  {href: ROUTES.HOW_TO_PAY, label:'How to Pay', key:'pay'},
  {href: ROUTES.COA, label:'Lab Tested', key:'coa'},
  {href: ROUTES.EDUCATION, label:'Education', key:'education'},
  {href: ROUTES.FAQ, label:'Support', key:'support'}
];
  var navHTML = NAV.map(function(n){
    return '<a href="'+n.href+'"'+(n.key===page?' class="hl"':'')+'>'+n.label+'</a>';
  }).join('');

  var crown='<svg class="crown" viewBox="0 0 64 64" fill="none"><defs><linearGradient id="cg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f4e39a"/><stop offset="1" stop-color="#c9a227"/></linearGradient></defs>'+
    '<path d="M10 46 L8 20 L20 32 L32 12 L44 32 L56 20 L54 46 Z" fill="url(#cg)"/><rect x="10" y="48" width="44" height="7" rx="2" fill="url(#cg)"/>'+
    '<circle cx="8" cy="18" r="3.4" fill="#f4e39a"/><circle cx="32" cy="9" r="3.8" fill="#f4e39a"/><circle cx="56" cy="18" r="3.4" fill="#f4e39a"/></svg>';

  var topHTML =
    '<div id="progress"></div>'+
    '<div class="amb"><div class="g g1"></div><div class="g g2"></div><div class="g g3"></div></div>'+
    '<div class="announce" style="display: none;">Third-Party Tested · 99% Purity <b>◆</b> USPS Priority Shipping <b>◆</b> For Research Use Only — Not for Human Consumption</div>'+
    '<header class="kc" style="display: none;"><div class="wrap nav">'+
      '<a class="brand" href="'+HOME+'">'+crown+'<span><span class="name">KING\'S COMPOUNDS</span><span class="sub">Research Peptides</span></span></a>'+
      '<nav class="menu" id="menu">'+navHTML+'</nav>'+
      '<div class="nav-icons">'+
        '<div class="ic search"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.6"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg></div>'+
        '<a class="ic" href="'+ROUTES.CONTACT+'"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.6"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg></a>'+
        '<div class="ic cart"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.6"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M6 6L5 3H2"/></svg><span class="dot">0</span></div>'+
        '<div class="burger" id="burger"><span></span><span></span><span></span></div>'+
      '</div>'+
    '</div></header>';

  var footHTML =
  '<footer class="kc" style="display: none;"><div class="wrap">'+
    '<div class="fgrid">'+

      '<div class="fbrand">'+
        '<div class="name">King\'s Compounds</div>'+
        '<p>Premium research-grade peptides for laboratory and scientific study. Quality you can verify, service you can trust.</p>'+
        '<div class="pay-badges">'+
          '<span>Venmo</span>'+
          '<span>CashApp</span>'+
          '<span>USPS Priority</span>'+
          '<span>18+ Only</span>'+
        '</div>'+
      '</div>'+

      '<div class="fcol">'+
        '<h5>Shop</h5>'+
        '<a href="'+ROUTES.CATALOG+'">All Products</a>'+
        '<a href="'+ROUTES.CATALOG+'">Metabolic Research</a>'+
        '<a href="'+ROUTES.CATALOG+'">Repair &amp; Structural</a>'+
        '<a href="'+ROUTES.CATALOG+'">Cognitive &amp; Neuro</a>'+
        '<a href="'+ROUTES.CATALOG+'">Lab Supplies</a>'+
      '</div>'+

      '<div class="fcol">'+
        '<h5>Learn</h5>'+
        '<a href="'+ROUTES.EDUCATION+'">What Are Peptides</a>'+
        '<a href="'+ROUTES.EDUCATION+'">Research Library</a>'+
        '<a href="'+ROUTES.HOW_TO_PAY+'">How to Pay</a>'+
        '<a href="'+ROUTES.COA+'">COA / Lab Testing</a>'+
        '<a href="'+ROUTES.ABOUT+'">About Us</a>'+
      '</div>'+

      '<div class="fcol">'+
        '<h5>Support</h5>'+
        '<a href="'+ROUTES.CONTACT+'">Contact Us</a>'+
        '<a href="'+ROUTES.FAQ+'">FAQ</a>'+
        '<a href="'+ROUTES.SHIPPING+'">Shipping</a>'+
        '<a href="'+ROUTES.RETURNS+'">Returns &amp; Refunds</a>'+
        '<a href="'+ROUTES.AFFILIATE+'">Affiliate Program</a>'+
      '</div>'+

    '</div>'+

    '<div class="disc">'+
      '<b>For Research Use Only — Not for Human Consumption.</b> '+
      'All products sold by King\'s Compounds are intended strictly for in-vitro laboratory research and analytical purposes. '+
      'They are not intended for human or veterinary use, and are not drugs, foods, or cosmetics. '+
      'These statements have not been evaluated by the U.S. Food and Drug Administration (FDA), and products are not intended to diagnose, treat, cure, or prevent any disease. '+
      'You must be 18 years or older to purchase.'+
    '</div>'+

    '<div class="fbot">'+
      '<span>© 2026 King\'s Compounds. All rights reserved.</span>'+
      '<div class="s">'+
        '<a href="#">Instagram</a>'+
        '<a href="#">TikTok</a>'+
        '<a href="'+ROUTES.PRIVACY+'">Privacy</a>'+
        '<a href="'+ROUTES.TERMS+'">Terms</a>'+
      '</div>'+
    '</div>'+

  '</div></footer>';

  // inject
  document.body.insertAdjacentHTML('afterbegin', topHTML);
  var main = document.querySelector('main');
  if(main){ main.insertAdjacentHTML('afterend', footHTML); }
  else { document.body.insertAdjacentHTML('beforeend', footHTML); }

  // progress bar
  var prog=document.getElementById('progress');
  window.addEventListener('scroll',function(){
    var h=document.documentElement.scrollHeight-window.innerHeight;
    prog.style.width=(h>0?window.scrollY/h*100:0)+'%';
  });
  // mobile menu
  var burger=document.getElementById('burger'), menu=document.getElementById('menu');
  if(burger){burger.addEventListener('click',function(){menu.classList.toggle('open')});}
  menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){menu.classList.remove('open')})});

  // accordions (.faq and .acc)
  function wireAcc(sel){
    document.querySelectorAll(sel+' p').forEach(function(q){
      q.addEventListener('click',function(){
        var f=q.parentNode, open=f.classList.contains('open');
        // only close siblings within same container group
        if(!open){ f.classList.add('open'); } else { f.classList.remove('open'); }
      });
    });
  }
  wireAcc('.faq'); wireAcc('.acc');

  // scroll reveal
  var io=new IntersectionObserver(function(en){en.forEach(function(e,i){
    if(e.isIntersecting){ setTimeout(function(){e.target.classList.add('in')}, rm?0:Math.min(i*55,240)); io.unobserve(e.target);}
  })},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){ if(rm){el.classList.add('in')} else io.observe(el); });

  // count-up
  function countUp(el){
    var t=+el.dataset.count, s=el.dataset.suffix||'', d=1300, t0=null;
    if(rm){el.textContent=t+s;return;}
    function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/d,1);
      el.textContent=Math.floor((1-Math.pow(1-p,3))*t)+s; if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var sio=new IntersectionObserver(function(en){en.forEach(function(e){ if(e.isIntersecting){countUp(e.target);sio.unobserve(e.target);} })},{threshold:.5});
  document.querySelectorAll('.num[data-count]').forEach(function(el){sio.observe(el)});

  // gallery thumbs (product page)
  document.querySelectorAll('.gallery .thumbs div').forEach(function(th){
    th.addEventListener('click',function(){
      var img=th.querySelector('img'); if(!img)return;
      var main=document.querySelector('.gallery .main img'); if(main)main.src=img.src;
      document.querySelectorAll('.gallery .thumbs div').forEach(function(x){x.classList.remove('on')});
      th.classList.add('on');
    });
  });

  // qty steppers
  document.querySelectorAll('.qty').forEach(function(q){
    var inp=q.querySelector('input'); var btns=q.querySelectorAll('button');
    if(btns[0])btns[0].addEventListener('click',function(){inp.value=Math.max(1,(+inp.value||1)-1)});
    if(btns[1])btns[1].addEventListener('click',function(){inp.value=(+inp.value||1)+1});
  });
})();
